import { gql } from '@apollo/client';

export const UPDATE_EXERCISE = gql`
    mutation updateExercise($id: ID!, $exerciseInput: ExerciseInput!){
        updateExercise(id: $id, exerciseInput: $exerciseInput) {
            _id
        }
    }
`;
